import { FormStatus } from "../types/client-forms.types";

export const CLIENT_FORM_STATUSES = Object.values(FormStatus);

const FORM_STATUS_DISPLAY = {
    [FormStatus.NOT_SENT]: "Not Sent",
    [FormStatus.SENT]: "Sent",
    [FormStatus.RECEIVED]: "Received",
    [FormStatus.NEEDS_CORRECTION]: "Needs Correction",
    [FormStatus.COMPLETED]: "Completed",
    [FormStatus.RECEIVED_RENEWAL]: "Received Renewal",
    [FormStatus.RENEWAL_SENT]: "Renewal Sent",
    [FormStatus.NO_LONGER_NEEDED]: "No Longer Needed",
    [FormStatus.FOLLOW_UPS_COMPLETED]: "Follow Ups Completed",
};

const FORM_STATUS_TAG = {
    [FormStatus.NOT_SENT]: "bg-[--color-danger-bg] text-[--color-danger-text]",
    [FormStatus.SENT]: "bg-[--color-info-bg] text-[--color-info-text]",
    [FormStatus.RECEIVED]: "bg-[--color-info-bg] text-[--color-info-text]",
    [FormStatus.RECEIVED_RENEWAL]:
        "bg-[--color-info-bg] text-[--color-info-text]",
    [FormStatus.RENEWAL_SENT]: "bg-[--color-info-bg] text-[--color-info-text]",
    [FormStatus.NO_LONGER_NEEDED]:
        "bg-[--color-info-bg] text-[--color-info-text]",
    [FormStatus.FOLLOW_UPS_COMPLETED]:
        "bg-[--color-info-bg] text-[--color-info-text]",
    [FormStatus.NEEDS_CORRECTION]:
        "bg-[--color-warning-bg] text-[--color-warning-text]",
    [FormStatus.COMPLETED]:
        "bg-[--color-success-bg] text-[--color-success-text]",
};

export const getStatusDisplay = (status: FormStatus) =>
    FORM_STATUS_DISPLAY[status as FormStatus] || status;

export const getStatusTag = (status: FormStatus) =>
    FORM_STATUS_TAG[status] || "bg-gray-100 text-gray-800 border-gray-200";
